module.exports = __webpack_public_path__ + "img/symbol_9.a9087159.png";